/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Button, Typography, Stack } from '@mui/material';
import { CheckOutlined, CloseOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function RequestActions({
  row,
  tabValue,
  onApproveClick,
  onRejectClick,
  onMarkSoldClick,
  onMarkNotSoldClick,
}) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const { requestStatus, transactionCompleted } = row;

  // PENDING → show approve / reject
  if (requestStatus === 'PENDING') {
    return (
      <Stack direction="row" spacing={1.5} sx={{ width: '100%' }} gap={3}>
        <Button
          variant="contained"
          startIcon={<CheckOutlined sx={{ fontSize: '15px' }} />}
          onClick={onApproveClick}
          sx={{
            flex: 1,
            backgroundColor: '#0CAF60',
            color: '#fff',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '12px',
            textTransform: 'none',
            py: 0.9,
            '&:hover': { backgroundColor: '#099B52' },
            gap: 0.5
          }}
        >
          {isRtl ? 'موافقة' : 'Approve'}
        </Button>
        <Button
          variant="contained"
          startIcon={<CloseOutlined sx={{ fontSize: '15px' }} />}
          onClick={onRejectClick}
          sx={{
            flex: 1,
            backgroundColor: '#E03137',
            color: '#fff',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '12px',
            textTransform: 'none',
            py: 0.9,
            '&:hover': { backgroundColor: '#C82A2F' },
            gap: 0.5
          }}
        >
          {isRtl ? 'رفض' : 'Reject'}
        </Button>
      </Stack>
    );
  }

  // COMPLETED & not yet marked → show sold / not sold
  if (requestStatus === 'COMPLETED' && transactionCompleted === null) {
    return (
      <Stack direction="row" spacing={1.5} sx={{ width: '100%' }} gap={3}>
        <Button
          variant="contained"
          startIcon={<CheckOutlined sx={{ fontSize: '15px' }} />}
          onClick={onMarkSoldClick}
          sx={{
            flex: 1,
            backgroundColor: '#0CAF60',
            color: '#fff',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '12px',
            textTransform: 'none',
            py: 0.9,
            '&:hover': { backgroundColor: '#099B52' },
            gap: 0.5
          }}
        >
          {isRtl
            ? tabValue === 1
              ? 'تم الإيجار'
              : 'تم البيع'
            : tabValue === 1
              ? 'Rented'
              : 'Sold'}
        </Button>
        <Button
          variant="contained"
          startIcon={<CloseOutlined sx={{ fontSize: '15px' }} />}
          onClick={onMarkNotSoldClick}
          sx={{
            flex: 1,
            backgroundColor: '#E03137',
            color: '#fff',
            borderRadius: '10px',
            fontWeight: 600,
            fontSize: '12px',
            textTransform: 'none',
            py: 0.9,
            '&:hover': { backgroundColor: '#C82A2F' },
            gap: 0.5
          }}
        >
          {isRtl
            ? tabValue === 1
              ? 'لم يتم الإيجار'
              : 'لم يتم البيع'
            : tabValue === 1
              ? 'Not Rented'
              : 'Not Sold'}
        </Button>
      </Stack>
    );
  }

  // Already marked → show result text
  if (transactionCompleted != null) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 20px',
          backgroundColor: transactionCompleted === '1' ? '#E7F7EF' : '#FFEDEC',
          borderRadius: '10px',
          width: '100%',

        }}
      >
        {transactionCompleted === '1' ? (
          <CheckOutlined sx={{ color: '#0CAF60', fontSize: '18px', mr: 1 }} />
        ) : (
          <CloseOutlined sx={{ color: '#E03137', fontSize: '18px', mr: 1 }} />
        )}
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 700,
            color: transactionCompleted === '1' ? '#0CAF60' : '#E03137',
          }}
        >
          {transactionCompleted === '1'
            ? tabValue === 1
              ? t('General.transactionRented')
              : t('General.transactionCompleted')
            : tabValue === 1
              ? t('General.notRented')
              : t('General.notSold')}
        </Typography>
      </Box>
    );
  }

  return null;
}
